import React, { useCallback, useEffect, useState } from "react";
import { Route, Redirect, useHistory, useLocation } from "react-router";
import { decodeToken, getToken, isLogged, unsetToken, updateProfileStore } from "./../services/auth";
import { ID_LAST_ROUTE } from "./../config/constants";
import Spinner from "../views/spinner/Spinner";
import { actions } from "./../redux/actions/auth";
import { useDispatch, useSelector } from "react-redux";
import { hasPermissionRoute } from "../services/permission";
import NotAuthorized from "../views/authentication/NotAuthorized";

export const PrivateRoute = ({ component: Component, ...rest }) => {
  const profile = useSelector((state) => state.auth.profile);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  const run = useCallback(async () => {
    const token = await getToken();
    const { _id, passTemp, termsAccepted, passChangeRequired } = profile;

    if (!token) {
      setLoading(false);
      history.push("/authentication/login");
      return;
    }

    const { decoded } = await decodeToken();
    if (!decoded) {
      await unsetToken();
      history.push("/authentication/login");
      return;
    }

    if (!_id && decoded) {
      const profileData = await updateProfileStore(decoded.id);
      dispatch(actions.setProfile(profileData));
    }

    setLoading(false);

    // if (termsAccepted === false && location.pathname !== "/termos-aceite") {
    //   history.push("/termos-aceite");
    //   return;
    // }

    if ((passTemp || passChangeRequired) && location.pathname !== "/meu-cadastro") {
      history.push("/meu-cadastro");
    }
  }, [profile, history, dispatch, location]);

  useEffect(() => {
    run();
  }, [run]);

  const logged = async () => {
    return isLogged();
  };

  return (
    <Route
      {...rest}
      render={(props) => {
        if (logged()) {
          if (loading) {
            return <Spinner />;
          } else {
            if (hasPermissionRoute(profile, rest.path)) {
              return <Component {...props} />;
            } else {
              return <NotAuthorized />;
            }
          }
        } else {
          localStorage.setItem(ID_LAST_ROUTE, props.location.pathname);
          return <Redirect to="/authentication/login" />;
        }
      }}
    />
  );
};

export default PrivateRoute;
